import { useGLTF } from '@react-three/drei';
import PropTypes from 'prop-types';

function SedeCarabaya({ status }) {
  const { nodes, materials } = useGLTF('/models/SedeCarabaya.gltf');
  const colorInactive = 'Grey';
  return (
    <group dispose={null}>
      <group
        position={[-6, -0.8, 21]}
        rotation={[-1.58, -1.6, 0]}
        scale={[0.8, 0.8, 0.8]}
      >
        <mesh geometry={nodes.Cubo057.geometry} material={materials['nude dark']} material-color={status === false ? colorInactive : null} />
        <mesh
          geometry={nodes.Cubo057_1.geometry}
          material={materials.nude}
          material-color={status === false ? colorInactive : null}
        />
        <mesh geometry={nodes.Cubo057_2.geometry} material={materials['grey dark']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo057_3.geometry} material={materials['grey dark']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo057_4.geometry} material={materials['grey dark.001']} material-color={status === false ? colorInactive : null} />
      </group>
    </group>
  );
}

useGLTF.preload('/models/SedeCarabaya.gltf');

export default SedeCarabaya;

SedeCarabaya.propTypes = {
  status: PropTypes.bool,
};

SedeCarabaya.defaultProps = {
  status: true,
};
